import React, { Suspense, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { CSpinner, useColorModes } from "@coreui/react";
import "./scss/style.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLazyProfileQuery } from "./features/auth/authApi.js";
import { logout, setCredentials } from "./features/auth/authSlice.js";

// import ProductForm from "./Components/admin/productmanagement/product/CommonForm";
// import ProductForm from "./Components/admin/productmanagement/product/CommonForm";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./Components/Login/Login.js"));
// const Register = React.lazy(() => import("./vie  ws/pages/register/Register"));
const Page404 = React.lazy(() => import("./Components/page404/Page404"));
const Page500 = React.lazy(() => import("./Components/page500/Page500"));

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes(
    "coreui-free-react-admin-template-theme",
  );
  const settings = useSelector((state) => state.settings);

  const auth = useSelector((state) => state.auth);
  const [profile] = useLazyProfileQuery();

  useEffect(() => {
    if (settings.theme) {
      setColorMode(settings.theme);
    }

    if (isColorModeSet()) {
      return;
    }

    setColorMode(settings.theme);
  }, []);

  // Auth Management
  // const auth = useSelector((state) => state.auth);
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getAuth = async () => {
    try {
      const res = await profile();

      if (res?.isSuccess) {
        if (location.pathname === "/") {
          navigate("/dashboard");
        }
        dispatch(
          setCredentials({
            user: res.data?.data,
          }),
        );
      } else {
        await dispatch(logout());
        if (location.pathname !== "/") {
          navigate("/");
        }
      }

      // if (res.success) {
      //   if (location.pathname === "/") {
      //     navigate("/dashboard");
      //   }
      // } else {
      //   await dispatch(AuthLogOut());

      //   if (location.pathname !== "/") {
      //     navigate("/");
      //   }
      // }

      // const res = await dispatch(GETAuthLogin());

      // if (res.payload.success) {
      //   if (location.pathname === "/") {
      //     navigate("/dashboard");
      //   }
      // } else {
      //   await dispatch(AuthLogOut());

      //   if (location.pathname !== "/") {
      //     navigate("/");
      //   }
      // }
    } catch (error) {
      console.error(error);
      navigate("/");
    }
  };

  useEffect(
    () => {
      getAuth();
    },
    [
      // signin
      // user?.user,
      // auth?.isAuthenticated,
    ],
  );

  // useEffect(() => {
  //   if (auth.isLogin) {
  //     navigate("/dashboard");
  //   } else {
  //     navigate("/");
  //   }
  // }, [auth]);

  return (
    // <HashRouter>
    <Suspense
      fallback={
        <div className="pp-app-loader" role="status" aria-live="polite">
          <CSpinner color="primary" />
          <span className="visually-hidden">Loading</span>
        </div>
      }
    >
      {/* !signin  */}
      {/* !user?.user */}
      {!auth?.isAuthenticated ? (
        <Login />
      ) : (
        // <Route exact path="/" name="Login Page" element={<Login />} />
        <Routes>
          <Route exact path="/" name="Login Page" element={<Login />} />
          {/* <Route
            exact
            path="/register"
            name="Register Page"
            element={<Register />}
          />*/}
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" name="Home" element={<DefaultLayout />} />
          {/* <Route path="/product-management/create" name="create" element={<ProductForm text="List" />} />
        <Route path="/product-management/edit" name="Edit" element={<ProductForm text="Edit" />} /> */}
        </Routes>
      )}
    </Suspense>
    // </HashRouter>
  );
};

export default App;
